import request from '@/utils/request'
import requestJxs from '@/utils/requestJxs'
import {getUserInfo} from '@/utils/common'
import {selectApi} from '@/config/config'
import {useUserInfoContext} from "@/store/userInfo";

// 获取视频专区列表
export const getVideoAreaList = (data) => {

    const userInfo = getUserInfo()
    if(userInfo.jxslx === 'SDGJJXS') {
        return requestJxs('/jxs/SyspMysql/list', {
            method: 'post',
            data: {
                ...data
            }
        })
    }
    return requestJxs('/jxs/Sysp/list', {
        method: 'post',
        data: {
            ...data
        }
    })
}

// 获取视频列表
export const getVideoList = (data) => {
    return request(selectApi, {
        params: {
            sqlfilename: 'jf-common.xml',
            sqlkey: 'sy-sp',
            ...data
        }
    })
}

// 获取视频详情
export const getVideoDetail = (id) => {
    return request(selectApi, {
        params: {
            sqlfilename: 'new-sql-xptj.xml',
            sqlkey: 'xptj-detail',
            id
        }
    })
}
// 获取视频详情
export const getSdgjVideoDetail = (id) => {
    return requestJxs('/jxs/SyspMysql/detail', {
        method: 'post',
        data: {
            sysId: id
        }
    })
}


// 部件目录区列表查询
export const getBjmlqList = (data) => {
    return requestJxs('/jxs/JxsCpxx/listLbjzq', {
        method: 'post',
        data: {
            ...data
        }
    })
}

// 部件目录区详情 -- 图片
export const getBjmlqDetailPics = (data) => {
    return requestJxs('/jxs/JxsCpxx/listLbjzqLbt', {
        method: 'post',
        data: {
            ...data
        }
    })
}

// 部件目录区详情 -- 列表数据
export const getBjmlqDetailList = (data) => {
    return requestJxs('/jxs/JxsCpxx/listLbjzqList', {
        method: 'post',
        data: {
            ...data
        }
    })
}


// // 部件目录区列表查询
// export const getBjmlqList = (keyword) => {
//     const userInfo = getUserInfo()
//     return request(selectApi, {
//         params: {
//             sqlfilename: "new-sql-web.xml",
//             sqlkey: "web-lbjzq-list-search",
//             dlid: userInfo.sysid,
//             keyword
//         }
//     })
// }
//
// // 部件目录区详情 -- 图片
// export const getBjmlqDetailPics = (data) => {
//     return request(selectApi, {
//         params: {
//             sqlfilename: "new-sql-cpgl.xml",
//             sqlkey: "cpda-bzt-tp-list",
//             ...data
//         }
//     })
// }
//
// // 部件目录区详情 -- 列表数据
// export const getBjmlqDetailList = (data) => {
//     const userInfo = getUserInfo()
//     return request(selectApi, {
//         params: {
//             sqlfilename: "new-sql-web.xml",
//             sqlkey: "web-lbjzq-list",
//             dlid: userInfo.sysid,
//             jxsbm: userInfo.jxsxx.partner,
//             ...data
//         }
//     })
// }

// 获取热销产品
export const getHotProduct = (data) => {
    const userInfo = getUserInfo()
    if(userInfo.jxslx === 'SDGJJXS') {
        return requestJxs('/jxs/WzglRxcpMysql/list', {
            method: 'post',
            data: {
                ...data,
                lx:"0"
            }
        })
    }else{
        return requestJxs('/jxs/Rxcp/list', {
            method: 'post',
            data: {
                ...data
            }
        })
    }
}

// 获取全品类商品列表
export const getQplcdqList = ({lbbm, keyword, pageIndex, pageSize}) => {
    const userInfo = getUserInfo()
    return request(selectApi, {
        params: {
            sqlfilename: 'new-sql-web.xml',
            sqlkey: 'qplxdq-cp-list',
            dlid: userInfo.sysid,
            jxsbm: userInfo.jxsxx.partner,
            lbbm,
            keyword,
            pageIndex,
            pageSize,
            pages: '1'
        }
    })
}
// // 获取全品类商品列表
// export const getQplcdqList = ({lbbm, keyword, pageIndex, pageSize}) => {
//   const userinfo = getUserInfo()
//   return request(selectApi, {
//     params: {
//       sqlfilename: 'new-sql-web.xml',
//       sqlkey: 'qplxdq-cp-list',
//       dlid: userinfo.sysid,
//       jxsbm: userinfo.jxsxx.partner,
//       lbbm,
//       keyword,
//       pageIndex,
//       pageSize,
//       pages: '1'
//     }
//   })
// }

// 获取全品类商品数量
export const getQplcdqCount = ({lbbm, keyword, pageIndex, pageSize}) => {
    const userInfo = getUserInfo()
    return request(selectApi, {
        params: {
            sqlfilename: 'new-sql-web.xml',
            sqlkey: 'qplxdq-cp-count',
            dlid: userInfo.sysid,
            jxsbm: userInfo.jxsxx.partner,
            lbbm,
            keyword,
            pageIndex,
            pageSize
        }
    })
}

// 获取产品详情
export const getProductDetail = (cpbm, type) => {
    const userInfo = getUserInfo()
    return request('/frontend/cpgl_cpdaqpl/detail.do', {
        params: {
            dlid: userInfo.sysid,
            jxsbm: userInfo.jxsxx.partner,
            cpbm,
            type
        }
    })
}
// 获取产品详情
export const getNewProductDetail = (cpbm, type) => {
    const userInfo = getUserInfo()
    return requestJxs('/jxs/SapCpxx/qplxdqCpDetailJgqy', {
        method: 'post',
        data: {
            dlid: userInfo.sysid,
            jxsbm: userInfo.jxsxx.partner,
            khbm: userInfo.jxsxx.partner,
            partner: userInfo.jxsxx.partner,
            cpbm,
            type
        }
    })

}

// 获取预览产品详情
export const getPreviewProductDetail = (id) => {
    return requestJxs('/jxs/JxsCpxx/detail', {
        method: 'post',
        data: {
            id,
        }
    })
}

// 轮播图
export const getLbt = () => {
    const userInfo = getUserInfo()
    if (userInfo?.jxslx === 'SDGJJXS') {
        return requestJxs('/jxs/WzglLbtMysql/list', {
            method: 'post',
            data: {
                zt: '启用',
                lx: '电脑',
                dxlx: '0'
            }
        })
    }else {
        return requestJxs('/jxs/WzglLbtNew/list', {
            method: 'post',
            data: {
                zt: '启用',
                lx: '电脑',
                dxlx: '0'
            }
        })
    }
}

// 轮播图
export const getLbtDetail = (id) => {
    const userInfo = getUserInfo()
    if (userInfo?.jxslx === 'SDGJJXS') {
        return requestJxs('/jxs/WzglLbtMysql/detail', {
            method: 'post',
            data: {
                zt: '启用',
                lx: '电脑',
                dxlx: '0',
                sysId: id
            }
        })
    }else {
        return requestJxs('/jxs/WzglLbtNew/detail', {
            method: 'post',
            data: {
                sysId: id
            }
        })
    }

}

// 添加收藏
export const addCollect = (data) => {
    const userInfo = getUserInfo()
    return requestJxs('/jxs/JxsWdsc/save', {
        method: 'post',
        data: {
            ...data,
            dlid: userInfo.sysid,
        }
    })
}

// 查看是否收藏
export const validateCollectStatus = (data) => {
    const userInfo = getUserInfo()
    return requestJxs('/jxs/JxsWdsc/sfsc', {
        method: 'post',
        data: {
            ...data,
            dlid: userInfo.sysid,
        }
    })
}

//收藏列表
export const getCollectList = (data) => {
    return requestJxs('/jxs/JxsWdsc/list', {
        method: 'post',
        data
    })
}

// 取消收藏
export const cancelCollect = (data) => {
    const userInfo = getUserInfo()
    return requestJxs('/jxs/JxsWdsc/deleteById', {
        method: 'post',
        data: {
            ...data,
            createname: userInfo.zhmc,
            jxsid: userInfo.jxsid,
            dlid: userInfo.sysid,
        }
    })
}

// 通知公告
export const getNoticeList = (data) => {
    const userInfo = getUserInfo()
    if (userInfo?.jxslx === 'SDGJJXS') {
        return requestJxs('/jxs/TzxxSdgj/listSy', {
            method: 'post',
            data: {
                ...data
            }
        })
    }else {
        return requestJxs('/jxs/Tzxx/listSy', {
            method: 'post',
            data: {
                ...data
            }
        })
    }
}

// 首页产品查询
export const getHomeProductList = (data) => {
    const userInfo = getUserInfo()
    if (userInfo?.jxslx === 'SDGJJXS') {
        return requestJxs('/jxs/SapCpxx/listSdgjJgqy', {
            method: 'post',
            data
        })
    }
    return requestJxs('/jxs/SapCpxx/listJgqy', {
        method: 'post',
        data
    })
}
// 首页产品查询
export const getHomeProductListSy = (data) => {
    const userInfo = getUserInfo()

    return requestJxs('/jxs/SapCpxx/listJgqySy', {
        method: 'post',
        data
    })
}
// // 首页产品查询
// export const getHomeProductList = (data) => {
//     const userInfo = getUserInfo()
//     return requestJxs('/jxs/SapCpxx/list', {
//         method: 'post',
//         data
//     })
// }
// 首页产品查询
// export const sdProductList = (data) => {
//     return requestJxs('/jxs/SdCpxx/list', {
//         method: 'post',
//         data
//     })
// }
// 首页产品查询
export const sdProductList = (data) => {
    return requestJxs('/jxs/SapCpxx/listJgqy', {
        method: 'post',
        data
    })
}
// 首页产品查询
export const sdgjProductList = (data) => {
    return requestJxs('/jxs/SapCpxx/listJgqy', {
        method: 'post',
        data
    })
}
// export const sdgjProductList = (data) => {
//     return requestJxs('/jxs/SdgjCpxx/list', {
//         method: 'post',
//         data
//     })
// }

// 获取首页新品推荐产品
export const getNewProduct = (data) => {

    const userInfo = getUserInfo()
    if(userInfo.jxslx === 'SDGJJXS') {
        return requestJxs('/jxs/WzglXptjMysql/list', {
            method: 'post',
            data
        })
    }else{
        return requestJxs('/jxs/Xpcp/list', {
            method: 'post',
            data: {
                ...data
            }
        })
    }
}

// 获取通知消息详情
export const getNoticeDetail = (id) => {
    return request('/backstage/wzgl_tzxx/detail.do', {
        params: {
            id
        }
    })
}

// 消息已读
export const readNotice = (id) => {
    const userInfo = getUserInfo()
    return request('/backstage/wzgl_tzxx/intoJxsRead.do', {
        params: {
            jxsbm: userInfo.jxsxx.partner,
            id
        }
    })
}

// 获取页面底部信息
export const getBottomInfo = () => {
    const userInfo = getUserInfo()
    if (userInfo) {
        return request(selectApi, {
            params: {
                sqlfilename: "new-sql-web.xml",
                sqlkey: "wzgl-dbxx-info",
                jxsbm: userInfo.jxsxx.partner,
            }
        })
    }
}

// 对账单提示
export const checkDzdQr = () => {
    const userInfo = getUserInfo()
    if (userInfo) {
        return request('/backstage/jxsgl_qpldd/checkDzdQr.do', {
            params: {
                partner: userInfo.jxsxx.partner,
            },
            autopass: true
        })
    }

}

export const checkSdfpQr = () => {
    const userInfo = getUserInfo()
    if (userInfo) {
        return request('/backstage/jxsgl_qpldd/checkSdfpQr.do', {
            params: {
                partner: userInfo.jxsxx.partner,
            },
            autopass: true
        })
    }
}

// 首页获取签署链接
export const getUnsignContractList1 = () => {
    const userInfo = getUserInfo()
    if (userInfo) {
        return requestJxs('/jxs/user/getUnsignContractList1', {
            method: 'post',
            data: {
                partner: userInfo.jxsxx.partner,
            }
        })
    }
}

// 首页获取签署链接2
export const getUnsignContractList2 = () => {
    const userInfo = getUserInfo()
    if (userInfo) {
        return requestJxs('/jxs/user/getUnsignContractList2', {
            method: 'post',
            data: {
                partner: userInfo.jxsxx.partner,
            }
        })
    }
}

// 获取首页新品推荐产品
export const checkTjgg = (data) => {
    return requestJxs('/jxs/Pzxx/getTjgg', {
        method: 'post',
        data: {
            ...data
        }
    })
}



// 轮播图
export const getLbtMysql = () => {
    return requestJxs('/jxs/WzglLbtMysql/list', {
        method: 'post',
        data: {
            zt: '启用',
            lx: '电脑',
            dxlx: '0'
        }
    })
}

// 轮播图
export const getLbtMysqlDetail = (id) => {
    return requestJxs('/jxs/WzglLbtMysql/detail', {
        method: 'post',
        data: {
            sysId: id
        }
    })
}

// 获取视频专区列表
export const getTftz = (data) => {
    return requestJxs('/jxs/Tfgl/getTftz', {
        method: 'post',
        data,
    });
};

export const selectCxtjBySearch = (data) => {
    const userInfo = getUserInfo();
    if (userInfo?.jxslx === 'SDGJJXS') {
    return requestJxs('/jxs/SapCpxx/listSdgjJgqyCxtj', {
      method: 'post',
      data: {
        ...data,
        dlid: userInfo.sysid,
        fxsid: userInfo.fxsid,
        jxsid: userInfo.jxsid,
        fxsbm: userInfo.jxsxx.partner,
        khbm:userInfo.khbm,
      }
    })
  }
    return requestJxs('/jxs/JxsCpxx/selectCxtjBySearch', {
        method: 'post',
        data: {
            ...data,
            dlid: userInfo.sysid,
            fxsid: userInfo.fxsid,
            jxsid: userInfo.jxsid,
            fxsbm: userInfo.jxsxx.partner,
            khbm:userInfo.khbm,
        }
    })
}
